import { GraphQLQuery } from '@settings/services/graphQLClient/GraphQLClient';
import gql from 'graphql-tag';

// Параметры мутации на удаление продукта из избранного
export interface DeleteArchivedProductMutationParams {
  id: string;
}

// Ответ мутации на удаление продукта из избранного
export interface DeleteArchivedProductMutationResponse {
  data: boolean;
}

// Мутация на удаление продукта из избранного
export class DeleteArchivedProductMutation
  implements GraphQLQuery<DeleteArchivedProductMutationParams>
{
  readonly query: any;

  readonly variables: DeleteArchivedProductMutationParams;

  constructor(params: DeleteArchivedProductMutationParams) {
    this.variables = {
      ...params,
    };

    this.query = gql`
      mutation __DELETE_PRODUCT_FROM_ARCHIVE__($id: ID!) {
        data: BitrixUserDeleteArchives(favouriteID: $id)
      }
    `;
  }
}
